import React from 'react';
import { DeBloatLanding } from './components/DeBloatLanding';
export function App() {
  return <DeBloatLanding data-id="element-0" />;
}